let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lcp5O")).then(() => parcelRequire('hKQLN'));